import './style.css'
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-copyright">
        Copyright © 2021 BookAnyCar All rights reserved.
      </div>
    </footer>
  );
};
export default Footer;